module.exports = __webpack_public_path__ + "img/img03_text_m.b9b3b7f8.png";